export type BrachialPressure = {
  systolic: Pressure;
  diastolic: Pressure;
};

export type Length = {
  meters: number;
};

export type Percent = {
  percent: number;
};

export type Pressure = {
  mmHg: number;
};

export type Weight = {
  kilograms: number;
};

export enum PolarResponse {
  Unknown = -1,
  No = 0,
  Yes = 1,
}

export enum HabitualStyle {
  Unknown = -1,
  Never = 0,
  Currently = 1,
  Previously = 2,
}

export enum HabitualFrequency {
  Unknown = -1,
  Never = 0,
  Occasionally = 1,
  Socially = 2,
  Daily = 3,
}

export type SmokingHabit = {
  style?: HabitualStyle;
  frequency?: HabitualFrequency;
  dailyCigarettes?: number;
  quitSmokingAt?: Date;
};

export type SnusHabit = {
  style?: HabitualStyle;
  frequency?: HabitualFrequency;
  dailyCans?: number;
  quitSnusingAt?: Date;
};

export type DrinkingHabit = {
  beer?: boolean;
  cocktails?: boolean;
  liquor?: boolean;
  spirits?: boolean;
  wine?: boolean;
  weeklyDrinks?: number;
};

export type PhysicalActivityHabit = {
  weeklyExerciseHours?: number;
  wearsHealthTracker?: boolean;
};

export enum Condition {
  AutoImmuneDiseases = "auto-immune-disease",
  Cancer = "cancer",
  Diabetes = "diabetes",
  HeartDisease = "heart-disease",
  MentalHealth = "mental-health",
}
